import React from "react";

//package import

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Button,
  DialogTitle,
  Box,
} from "@mui/material";

//component

const DelModal = ({ header, status, open, handleClose, statusHandler }) => {
  //hooks

  // render
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      // fullWidth={true}
      sx={{
        color: "gray",
        borderRadius: 2,
      }}
    >
      {" "}
      <Box height={"60px"} bgcolor={"#00008b33"}>
        <DialogTitle
          sx={{
            fontWeight: 500,
            fontSize: "15px",
            lineHeight: "22px",
            textAlign: "center",
          }}
        >
          {header}
        </DialogTitle>
      </Box>
      <DialogContent>
        <DialogContentText sx={{ textAlign: "center", paddingY: 2 }}>
          Are you sure you want to {status ? "Unblock" : "Block"} the User?
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ margin: "auto" }}>
        <Box
          display={"flex"}
          justifyContent={"space-around"}
          gap={"2vw"}
          paddingBottom={2}
        >
          <Button
            onClick={handleClose}
            variant="contained"
            sx={{ borderRadius: 1, backgroundColor: "gray", width: "100px" }}
          >
            No
          </Button>

          <Button
            variant="contained"
            onClick={statusHandler}
            sx={{
              borderRadius: 1,
              width: "100px",
            }}
            autoFocus
          >
            Yes
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default DelModal;
